<template>
  <div :style="{'background-image':'url(' + thumb + ')'}" class="imageFolder">

    <!--hover蒙层-->
    <div class="imageFolderHoverMantle imageFolderHoverShow" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;background:rgba(0, 0, 0, 0.4);border-radius:6px;"></div>

    <div class="imageFolder-title">
<!--      <v-img src="../../../assets/globe/image_lib/folderIcon.png" style="width:21px;float:left;"></v-img>-->
      <p style="width:calc(100% - 30px);overflow: hidden;text-overflow:ellipsis;white-space: nowrap;float:left;text-shadow: 0px 0px 4px  rgba(0, 0, 0, 0.75);">{{title}}</p>
    </div>
<!--    <div style="position:absolute;top:0;right:0;width:35px;height:35px;background:rgba(255,255,255,0.6);text-align:center;">-->
<!--      <p style="color:#000000;font-size:12px;line-height:35px;">{{contentNum}}</p>-->
<!--    </div>-->


    <!--hover说明文字-->
    <div class="imageFolderHoverShow" style="position:absolute;bottom:4px;left:0;right:0;width:100%;height:17px;padding:0 10px;font-size:14px;color:#ffffff;">
      <p style="line-height:17px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" class="ma-0">{{remark}}</p>
    </div>


  </div>

</template>

<script>
export default {
  name: "ImageFolder",
  props:["thumb","title","contentNum","remark"]


}
</script>

<style scoped>

.imageFolder{
  position:relative;
  width:145px;
  height:145px;
  border:1px solid #a6a6a6;
  border-radius:6px;
  background-size:cover;
  background-position: center;
  cursor:pointer;
}
.imageFolder:hover{
  border:1px solid #ffffff;
}

.imageFolderHoverShow{
  display:none;
}
.imageFolder:hover .imageFolderHoverShow{
  display:block;
}

/*hover蒙层出现动画*/
@keyframes imageFolderHoverMantleShow {
  from {width:0;height:0;}
  to {width:100%;height:100%;}
}
.imageFolderHoverMantle{
  animation: imageFolderHoverMantleShow 0.03s linear;
}


.imageFolder-title{
  position:absolute;
  top:5px;
  left:10px;
  width:calc(100% - 20px);
  font-size:16px;
  color:#ffffff;
  font-weight:bold;
}

</style>